import { LIMIT } from '@constants';
import { request } from '@utils';

const report = async (type) => {
  const params = {
    type,
    responseType: 'arraybuffer',
  };
  const results = await request.get(`/v1/pipedrive/events/export`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getCreditCheckData = async (payload = {}) => {
  const params = {
    page: 1,
    pageSize: LIMIT,
    ...payload,
  };

  const results = await request.get(`/v1/creditCheck`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getCreditCheckDataFilter = async ({ payload = {}, urlParams = {} }) => {
  const requestBody = {
    body: payload,
  };
  const results = await request.post(
    `/v1/creditCheck/filter?${new URLSearchParams(urlParams)}`,
    requestBody
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const exportCreditCheckReport = async ({ rule = {}, params = {} } = {}) => {
  const body = {
    body: {
      type: 'csv',
      rule: {
        type: 2,
        ...rule,
      },
    },
  };

  const queryString = new URLSearchParams(params).toString();
  const url = queryString
    ? `/v1/creditCheck/export?${queryString}`
    : `/v1/creditCheck/export`;
  const results = await request.post(url, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateCreditCheckData = async (id, payload) => {
  const results = await request.patch(`/v1/creditCheck/${id}`, {
    body: payload,
  });

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

export {
  report,
  getCreditCheckData,
  getCreditCheckDataFilter,
  exportCreditCheckReport,
  updateCreditCheckData as updateTask,
};
